export default "__VITE_ASSET__BiC7Tc8$__"